import { AthosFetcher } from 'libs/athos/classes/athos-fetcher'
import { normaliseResults } from 'libs/athos/helpers/normalisers'
import { generateAthosProvider } from 'libs/athos/fetchers/provider'
import type { AthosFetchOptions } from 'libs/athos/athos.types'

export class AthosProduct extends AthosFetcher {
  generateURL() {
    return super.generateURL('/search')
  }

  updateParams(options: AthosFetchOptions = {}) {
    const { handle } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('resultsPerPage', 1)
    this.params.set('bgfilter.handle', handle)

    super.updateParams()
  }
}

export const AthosProductProvider = generateAthosProvider(AthosProduct, async (results) => {
  const normalisedResults = await normaliseResults(results.results)
  return {
    ...results,
    results: normalisedResults
  }
})
